import {
  Accordion as AccordionWrapper,
  Box,
  type BoxProps,
  Text,
  Title,
} from "@qws-org/ui-kit";
import type { FC } from "react";
import { useState } from "react";

import type { Accordion as AccordionData } from "~/core";

export type AccordionProps = {
  data: AccordionData;
} & Partial<Omit<BoxProps, "display">> & {
    display?: "block" | "hidden";
  };

export const Accordion: FC<AccordionProps> = (props) => {
  const { data, ...rest } = props;

  const [expandedKeys, setExpandedKeys] = useState<Set<ID>>();

  return (
    <Box {...rest}>
      {data.title && <Title horizontalAlign="center">{data.title}</Title>}
      {data.description && (
        <Text content={data.description} horizontalAlign="center" />
      )}

      <AccordionWrapper
        onExpandedChange={setExpandedKeys}
        expandedKeys={expandedKeys}
      >
        {data.items?.map((item) => (
          <AccordionWrapper.Item
            title={item?.accordion_items_id?.name}
            key={item?.accordion_items_id?.id}
          >
            <Text content={item?.accordion_items_id?.text ?? ""} />
          </AccordionWrapper.Item>
        ))}
      </AccordionWrapper>
    </Box>
  );
};
